import React from "react";
import { Check, X, DollarSign } from "lucide-react";

// Shared status -> icon mapping for pricing feature lists + comparison matrix.
export function FeatureStatusIcon({ status, className = "" }) {
  if (status === "not_included") {
    return <X className={`h-4 w-4 shrink-0 text-muted-foreground/50 ${className}`} data-status="not_included" />;
  }
  if (status === "addon") {
    return <DollarSign className={`h-4 w-4 shrink-0 text-amber-600 ${className}`} data-status="addon" />;
  }
  return <Check className={`h-4 w-4 shrink-0 text-primary ${className}`} data-status="included" />;
}

export const LABEL_TEXT = { coming_soon: "Coming soon", beta: "Beta" };

export function FeatureLabelBadge({ label }) {
  if (!label || !LABEL_TEXT[label]) return null;
  const tone = label === "beta" ? "bg-sky-50 text-sky-700" : "bg-amber-50 text-amber-700";
  return (
    <span className={`ml-1.5 inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-[640] uppercase tracking-wide ${tone}`}>
      {LABEL_TEXT[label]}
    </span>
  );
}
